import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import {
  getProductImages,
  ProductImage,
} from "../../../utilities/product-images";

@Component({
  selector: "app-product-images",
  templateUrl: "./product-images.component.html",
  styleUrls: ["./product-images.component.css"],
})
export class ProductImagesComponent implements OnInit {
  products: ProductImage[] = [];
  selectedProduct: ProductImage | null = null;

  @Output() selectedProductsChange = new EventEmitter<ProductImage[]>();

  constructor() {}

  ngOnInit(): void {
    this.products = getProductImages();
  }

  getBackgroundImageStyle(imageUrl: string): string {
    if (!imageUrl) {
      return "none";
    }
    return `url("${imageUrl}")`;
  }

  toggleSelection(product: ProductImage): void {
    // If clicking the same product that's already selected, deselect it
    if (this.selectedProduct?.productID === product.productID) {
      this.selectedProduct = null;
    } else {
      // Otherwise, select the new product (replacing any previous selection)
      this.selectedProduct = product;
    }

    // Emit the updated selected products array (single item or empty)
    this.selectedProductsChange.emit(
      this.selectedProduct ? [this.selectedProduct] : []
    );
  }

  isSelected(product: ProductImage): boolean {
    return this.selectedProduct?.productID === product.productID;
  }
}
